import 'core-js/stable';
import 'regenerator-runtime/runtime';

const jQuery = require('jquery');

window.jQuery = jQuery;
window.$ = jQuery;
require('./common/polyfills');
require('./common/monitors/scroll').init();

const processInclude = require('base/util');

require('./analytics').init();

const designSystem = require('./components/ds');

designSystem.init();

$(() => {
  require('./components/fullPageBanner').init();
  require('./cart/localCart').init();
  require('./interactions/index');
  require('./components/forms').init();
  processInclude(require('./components/buttons'));
  processInclude(require('./components/menu'));
  processInclude(require('base/components/cookie'));
  processInclude(require('./components/dialogModal'));
  require('./components/modals').init();
  require('./components/cartRecoveryModal').init();
  require('./components/tooltips').init();
  require('./components/footerLoader').init();
  processInclude(require('./components/newsletter'));
  processInclude(require('./components/header'));
  processInclude(require('./components/header-popup'));
  processInclude(require('./components/miniCart'));
  processInclude(require('base/components/search'));
  require('./components/clientSideValidation').init();
  processInclude(require('./product/vue')); // Unified product/detail and /product/quickView
  processInclude(require('./product/wishlist'));
  processInclude(require('./animations'));
  processInclude(
    require('./components/countrySelectorModal/countrySelectorModal')
  );
  require('./components/slots').default();
  require('./vue');
  require('./page').init();
});

require('./thirdParty/bootstrap');
require('./thirdParty/keynav-detect');
require('base/components/spinner');
